/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Checkbox tree for checkbox selecting
     */
    let checkboxTree = $('.checkbox-tree :checkbox');
    checkboxTree.on('click change', function (){
        if($(this).is(':checked')) {
            // $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true);
        } else {
            // $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    checkboxTree.each(function () {
        if($(this).is(':checked')) {
            // $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();

        Swal.fire({
            title: 'Tem certeza de que deseja excluir este item?',
            showCancelButton: true,
            confirmButtonText: 'Excluir',
            cancelButtonText: 'Cancelar',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            Swal.fire({
                title: 'Você tem certeza de que quer fazer isso?',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.fire({
            title: 'Você tem certeza de que quer fazer isso?',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            icon: 'info',
        }).then((result) => {
            result.value && window.location.assign($(this).attr('href'));
        });
    })

    .on('submit', 'form[name=decision-item]', function (e) {
        e.preventDefault();

        const form = this;

        const inputAccept = document.createElement('input');
        inputAccept.type = 'hidden';
        inputAccept.id = 'confirmed';
        inputAccept.name = 'confirmed';
        inputAccept.value = 0;

        form.appendChild(inputAccept);

        Swal.fire({
            title: 'Você quer fazer isso?',
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: 'Aceitar',
            denyButtonText: 'Recusar',
            cancelButtonText: 'Cancelar',
            icon: 'warning'
        }).then((result) => {
            if (result.isConfirmed) {
                form.querySelector('input#confirmed').value = 1;
                form.submit();
            }
            else if (result.isDenied){
                form.submit();
            }
            else {
                enableSubmitButtons($(form));
            }
        });
    });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="'+hash+'"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();












    // Password Input 

    $(".password-input button").on('click', function(event) {
        event.preventDefault();
        const btn = event.target;
        const rootDir =  $(btn).is('button') ? btn.parentElement.parentElement : btn.parentElement.parentElement.parentElement;
        const div = rootDir.querySelector('.input-group-append');
        const input = rootDir.querySelector('input');
        const icon = div.querySelector('i');

        if($(input).attr("type") == "text"){
            $(input).attr('type', 'password');
            $(icon).addClass( "fa-eye-slash" );
            $(icon).removeClass( "fa-eye" );
        } else if($(input).attr("type") == "password"){
            $(input).attr('type', 'text');
            $(icon).removeClass( "fa-eye-slash" );
            $(icon).addClass( "fa-eye" );
        }
    });






});
